/* TONERY — Contact page reveal-on-scroll (guarded) */
(function(){
  if(window.__tconInit) return; window.__tconInit = true;
  function reveal(scope){
    var els=(scope||document).querySelectorAll('.tcon .reveal:not(.in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(x){x.classList.add('in');}); return; }
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:.08});
    els.forEach(function(x){io.observe(x);});
  }
  reveal(document);
  document.addEventListener('shopify:section:load', function(e){ reveal(e.target); });
})();
